
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as component_45stubfviNpbLidNhQKLXRRAKVJED_d2NsAnvUOk4r_zuaxew } from "/builds/eotlab/eotlab-website/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubfviNpbLidNhQKLXRRAKVJED_d2NsAnvUOk4r_zuaxewMeta } from "/builds/eotlab/eotlab-website/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "publications-slug___en",
    path: "/publications/:slug()",
    component: () => import("/builds/eotlab/eotlab-website/pages/publications/[slug].vue")
  },
  {
    name: "publications-slug___de",
    path: "/de/publications/:slug()",
    component: () => import("/builds/eotlab/eotlab-website/pages/publications/[slug].vue")
  },
  {
    name: "articles-slug___en",
    path: "/articles/:slug(.*)*",
    component: () => import("/builds/eotlab/eotlab-website/pages/articles/[...slug].vue")
  },
  {
    name: "articles-slug___de",
    path: "/de/articles/:slug(.*)*",
    component: () => import("/builds/eotlab/eotlab-website/pages/articles/[...slug].vue")
  },
  {
    name: "persons-slug___en",
    path: "/persons/:slug(.*)*",
    component: () => import("/builds/eotlab/eotlab-website/pages/persons/[...slug].vue")
  },
  {
    name: "persons-slug___de",
    path: "/de/persons/:slug(.*)*",
    component: () => import("/builds/eotlab/eotlab-website/pages/persons/[...slug].vue")
  },
  {
    name: "articles___en",
    path: "/articles",
    component: () => import("/builds/eotlab/eotlab-website/pages/articles/index.vue")
  },
  {
    name: "articles___de",
    path: "/de/articles",
    component: () => import("/builds/eotlab/eotlab-website/pages/articles/index.vue")
  },
  {
    name: "persons___en",
    path: "/persons",
    component: () => import("/builds/eotlab/eotlab-website/pages/persons/index.vue")
  },
  {
    name: "persons___de",
    path: "/de/persons",
    component: () => import("/builds/eotlab/eotlab-website/pages/persons/index.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/builds/eotlab/eotlab-website/pages/privacy/index.vue")
  },
  {
    name: "privacy___de",
    path: "/de/privacy",
    component: () => import("/builds/eotlab/eotlab-website/pages/privacy/index.vue")
  },
  {
    name: "publications___en",
    path: "/publications",
    component: () => import("/builds/eotlab/eotlab-website/pages/publications/index.vue")
  },
  {
    name: "publications___de",
    path: "/de/publications",
    component: () => import("/builds/eotlab/eotlab-website/pages/publications/index.vue")
  },
  {
    name: "theses___en",
    path: "/theses",
    component: () => import("/builds/eotlab/eotlab-website/pages/theses/index.vue")
  },
  {
    name: "theses___de",
    path: "/de/theses",
    component: () => import("/builds/eotlab/eotlab-website/pages/theses/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/builds/eotlab/eotlab-website/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/builds/eotlab/eotlab-website/pages/index.vue")
  },
  {
    name: component_45stubfviNpbLidNhQKLXRRAKVJED_d2NsAnvUOk4r_zuaxewMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubfviNpbLidNhQKLXRRAKVJED_d2NsAnvUOk4r_zuaxew
  }
]